module.exports = __webpack_public_path__ + "img/shuixi07.ed1dd166.png";